
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teach",
      function () {
        return require("private-next-pages/teach.tsx");
      }
    ]);
  